// extracted by mini-css-extract-plugin
export default {"close":"close-button_close__8zwN1","line":"close-button_line__JiFGm","bg-white":"close-button_bg-white__nTCwn"};